import axios from 'axios';

export const getAllHomes = async () => {
    const url = `/api/v1/user_profile/homes`;
    const res = await axios.get(url);
    return res.data;
};

export const getHome = async (id) => {
    const url = `/api/v1/user_profile/homes/${id}`;
    const res = await axios.get(url);
    return res.data;
};

export const createHome = async (data) => {
    const url = `/api/v1/user_profile/homes`;
    const res = await axios.post(url, data);
    return res.data;
}

export const createHomePhoto = async (homeId, formData) => {
    const url = `/api/v1/user_profile/homes/${homeId}/home_photos`;
    const config = {headers: { "Content-Type": "multipart/form-data" }}

    const res = await axios.post(url, formData, config);
    return res.data;
}

export const updateHomePhoto = async (photoId, data) => {
    const url = `/api/v1/user_profile/home_photos/${photoId}`;

    const res = await axios.patch(url, data);
    return res.data;
}

export const deleteHomePhoto = async (photoId) => {
    const url = `/api/v1/user_profile/home_photos/${photoId}`;
    const res = await axios.delete(url);
    return res.data;
}

export const updateHome = async(homeId, data) => {
    const url = `/api/v1/user_profile/homes/${homeId}`
    const res = await axios.patch(url, data);
    return res.data;
}

export const updateHomeIcon = async (homeId, formData) => {
    const url = `/api/v1/user_profile/homes/${homeId}`
    const config = {headers: { "Content-Type": "multipart/form-data" }}
    const res = await axios.patch(url, formData, config);
    return res.data;
}

export const updateHomeServiceJoins = async (homeId, data) => {
    const url = `/api/v1/user_profile/homes/${homeId}/home_service_joins`;
    const res = await axios.post(url, data);
    return res.data;
}

// Archive a home
export const archiveHome = async (homeId) => {
    const url = `/api/v1/user_profile/homes/${homeId}/archive`;
    const res = await axios.post(url);
    return res.data;
}